import { useQuery } from '../../../../ReactQuery';
import { get } from '../../../../redux/api';
import type { GitHubAppInstallationResponse } from '../../../../../shared/types/routes/vcs/githubApp';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

const fetchGitHubAppInstallation = (app: VcsApp) => {
  return get<GitHubAppInstallationResponse>(`/api/vcs/github-apps/${app}/installation`);
};

export const getGitHubAppInstallationQueryKey = (app: VcsApp) =>
  ['vcs', 'github-apps', app, 'installation'] as const;

/**
 * Reports whether the current user's org has the given vcs-app installed.
 * Used to switch between rendering "Install"/"Disconnect" buttons.
 */
export function useGitHubAppInstallation(app: VcsApp) {
  return useQuery({
    queryKey: getGitHubAppInstallationQueryKey(app),
    queryFn: () => fetchGitHubAppInstallation(app),
  });
}
